module.exports = __webpack_public_path__ + "media/components/assets/img/bg/sidebar-c3cc92f6c236cb6bac53fc2560ee2739.svg";